import _ from "lodash";
import React from "react";
import { connect } from "react-redux";

import MediaModal from "UIComponents/MediaModal";
import TheatreModeV2 from "UIComponents/TheatreModeV2";
import { showNewTheatreMode } from "Utils/GetTheatreModeType";
import {
  setMediaViewerModalState,
  getMessagingV2ReduxState,
} from "MessagingV2/modules/MessagingModule";
import { isMessagingV2Enabled } from "MessagingV2/modules/Utils";

const MessagingV2MediaViewer = props => {
  const isPerm = isMessagingV2Enabled();
  const { mediaViewerData, setMediaViewerModalState } = props;

  const closePreviewModal = () => {
    setMediaViewerModalState(null);
  };

  if (_.isEmpty(mediaViewerData) || !isPerm) {
    return null;
  }

  const { attachments, activeAttachmentIndex } = mediaViewerData;

  return showNewTheatreMode() ? (
    <TheatreModeV2
      mediaAttachments={{ attachments }}
      activeAttachmentIndex={activeAttachmentIndex}
      toggleTheatreMode={closePreviewModal}
    />
  ) : (
    <MediaModal
      toggleMediaModal={closePreviewModal}
      attachments={attachments}
      activeIndex={activeAttachmentIndex}
      videoAutoPlayOnClick
      showDownloadVideoButton
    />
  );
};

const mapStateToProps = state => {
  const messagingState = getMessagingV2ReduxState(state);
  return { mediaViewerData: _.get(messagingState, "mediaViewerData", null) };
};

const mapDispatchActions = { setMediaViewerModalState };

export default connect(
  mapStateToProps,
  mapDispatchActions
)(MessagingV2MediaViewer);
